import { isBoolean, isNumber } from 'lodash-es'

import { storage } from '../../web/storage'

import { System } from './System'

export class PrefsSystem extends System {
  constructor(client) {
    super(client)

    const isQuest = /OculusBrowser/.test(navigator.userAgent)

    let data = storage.get('prefs', {})

    // v1: init
    if (!data.v) {
      data.v = 1
    }

    this.v = data.v
    this.viewDistance = isNumber(data.viewDistance) ? data.viewDistance : 8
    this.music = isNumber(data.music) ? data.music : 1
    this.sfx = isNumber(data.sfx) ? data.sfx : 1
    this.voice = isNumber(data.voice) ? data.voice : 1
    this.stats = isBoolean(data.stats) ? data.stats : false

    this.changes = null
  }

  init() {
    // this.world.chat.bindCommand('stats', () => {
    //   this.setStats(!this.stats)
    // })
  }

  preFixedUpdate() {
    if (!this.changes) return
    this.emit('change', this.changes)
    this.changes = null
  }

  set(key, value) {
    if (this[key] === value) return
    const prev = this[key]
    this[key] = value
    if (!this.changes) this.changes = {}
    if (!this.changes[key]) this.changes[key] = { prev, value: null }
    this.changes[key].value = value
    this.persist()
  }

  async persist() {
    // a small delay to ensure prefs that crash dont persist (eg old iOS with UHD shadows etc)
    await new Promise(resolve => setTimeout(resolve, 2000))
    storage.set('prefs', {
      v: this.v,
      viewDistance: this.viewDistance,
      music: this.music,
      sfx: this.sfx,
      voice: this.voice,
      stats: this.stats,
    })
  }

  destroy() {
    // ...
  }
}
